import api, { getParams } from './'

const generalEndpoints = {
  getFAQCategories: () => api.get(`general/faqs/categories`),
  getFAQ: type => api.get(`general/faqs${getParams({ type })}`),
  getEvolveMigrationSetting: () => api.get(`general/setting/evolve_migration`),
  generalError: error_stack => api.post(`general/error`, { error_stack }),
  getGeneralSetting: setting => api.get(`general/setting/${setting}`), // evolve_migration | insurance_disabled
  getAIModels: () => api.get(`general/ai/models`),
  getAIModel: modelID => api.get(`general/ai/model/${modelID}`),
  sendAIChat: data => api.post(`general/ai/chat`, data),
  // sendAICompletion: data => api.post(`general/ai/chat`, data),
  sendAICompletion: data => api.post(`general/ai/completion`, data),
  getAIFineTune: () => api.get(`general/ai/fine_tune`),
  sendCustomerServiceRequest: data => api.post(`general/chat/support`, data),
  getChatbotResponse: data => api.post(`general/chat/bot`, data),
  getGPTEverythingSearch: data => api.post(`general/gpt/everything_search`, data),
  getGPTDestinationDetails: data => api.post(`general/gpt/destination_details`, data),
  getGPTDestinationExtras: data => api.post(`general/gpt/destination_extras`, data),
  getGPTDestinationRecommendations: data => api.post(`general/gpt/destination_recommendations`, data),
  getGPTSimilarDestinations: data => api.post(`general/gpt/similar_destinations`, data),
  getGPTRecommendedExperiences: data => api.post(`general/gpt/recommended_experiences`, data),
}

export default generalEndpoints